import { z } from "zod";
import { BillingInvoiceItemSchema } from "./billing-invoice-item";
import { ResultDataSchema } from "../result-data/result-data";

export const BillingInvoiceResultSchema = ResultDataSchema.extend({
  Results: BillingInvoiceItemSchema.array(),
});

export type BillingInvoiceResultType = z.infer<
  typeof BillingInvoiceResultSchema
>;
